import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import { Cnt } from "../Cnt.ThreeDeeCrate.SDK/Cnt.ThreeDeeCrate.SDK";
import { AppSettings } from "../AppSettings";
import { EMPTY_GUID } from "../types/Guid";
import { ThumbnailProgress } from "./ProgressBars/ThumbnailProgress";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Card, Modal } from "react-bootstrap";
import { ModelModalContent } from "./ModelModalContent";

export const BrowseModels: React.FC = () => {
  const [models, setModels] = useState<Cnt.ThreeDeeCrate.SDK.ContainerDTO[]>([]);
  const [selectedModel, setSelectedModel] = useState<Cnt.ThreeDeeCrate.SDK.ContainerModelDTO | null>(null);
  const [showModal, setShowModal] = useState(false);
  useEffect(() => {
    const api = new Cnt.ThreeDeeCrate.SDK.Api(AppSettings.APIUrl);

    const fetchModels = async () => {
      try {
        const latest: Cnt.ThreeDeeCrate.SDK.ContainerDTO[] = await api.model.GetLatestModels(1);
        const recommended: Cnt.ThreeDeeCrate.SDK.ContainerDTO[] = await api.model.GetRecommendedModels(10);

        // 🔄 Combine everything into one array
        const combined: Cnt.ThreeDeeCrate.SDK.ContainerDTO[] = [
          
          ...(latest ?? []),
          ...(recommended ?? [])
        ];

        setModels(combined);
      } catch (err) {
        console.error("❌ Failed to load browse models", err);
      }
    };

    fetchModels();
  }, []);

  if (!models.length) return null;

  const settings = {
    infinite: true,
    speed: 10000,
    slidesToShow:4,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 0,
    cssEase: "linear",
  arrows: false
  };
  const handleModelClick = async (model: Cnt.ThreeDeeCrate.SDK.ContainerDTO) => {
    try {
      const api = new Cnt.ThreeDeeCrate.SDK.Api(AppSettings.APIUrl);
      const fullModel = await api.model.GetModelInformation(model.Id ?? '');
      setSelectedModel(fullModel);
      setShowModal(true);
    } catch (err) {
      console.error('Failed to fetch full model info:', err);
    }
  };
  return (
        //   <Card className="shadow-lg" style={{ cursor: 'pointer' }}>
        // <Card.Body>
        <div style={{cursor:"pointer"}}>
      <Slider {...settings}>
        {models.map((m) => (
          <div key={m?.Id || Math.random()} className="px-2" onClick={()=>{handleModelClick(m)}}>
            <ThumbnailProgress
              name={""}
              description={""}
              containerId={m?.Id ?? EMPTY_GUID}
              status={Cnt.ThreeDeeCrate.SDK.GenerationStatusType.Done}
              height={"176px"}
              smallThumbnail={true}
              isRecommended={true}
            />
          </div>
        ))}
      </Slider>
            <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{selectedModel?.Container?.Name}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ModelModalContent model={selectedModel} />
        </Modal.Body>
      </Modal>
      </div>
      //   </Card.Body>
      // </Card>

  );
};
